import { render } from "./WorkflowSettingsTemplateEventsRoles.vue?vue&type=template&id=8c866a22&scoped=true"
import script from "./WorkflowSettingsTemplateEventsRoles.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsTemplateEventsRoles.vue?vue&type=script&lang=js"

import "./WorkflowSettingsTemplateEventsRoles.vue?vue&type=style&index=0&id=8c866a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c866a22"]])

export default __exports__